import React from 'react'
import { GiCompass, GiDiamondHard, GiStabbedNote } from 'react-icons/gi'
export const links = [
  {
    id: 1,
    text: 'home',
    url: '/',
  },
  {
    id: 2,
    text: 'about',
    url: 'about',
  },
  {
    id: 3,
    text: 'products',
    url: 'products',
  },
]

export const services = [
  {
    id: 1,
    icon: <GiCompass />,
    title: 'our vision',
    text:
      'To become a world-class online store known for quality and reliability.',
  },
  {
    id: 2,
    icon: <GiDiamondHard />,
    title: 'our mission',
    text:
      'Ensuring customer satisfaction through providing authentic products and providing unmatched customer care services.',
  },
  {
    id: 3,
    icon: <GiStabbedNote />,
    title: 'our pledge',
    text:
      'We pledge to be consistent, reliable and to continuously be efficient and effective.',
  },
]

export const products_url = 'https://course-api.com/react-store-products'

export const single_product_url = `https://course-api.com/react-store-single-product?id=`
